import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { WhiteButton } from 'components/Common/Button';
import { IOrderListItem } from 'models/orders/order';
import { OrderStatus } from 'models';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IOrderListItem;
	rejectOrder?: (item: IOrderListItem) => void;
	confirmOrder?: (shopOrderId: string, orderId: string) => void;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopDashboardOrderItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.handleViewItemClick = this.handleViewItemClick.bind(this);
		this.handleRejectOrderClick = this.handleRejectOrderClick.bind(this);
		this.handleConfirmClick = this.handleConfirmClick.bind(this);
	}

	private handleViewItemClick() {
		if (this.props.viewItem) {
			this.props.viewItem(this.props.item.id);
		}
	}
	private handleRejectOrderClick() {
		if (this.props.rejectOrder) {
			this.props.rejectOrder(this.props.item);
		}
	}

	private handleConfirmClick() {
		if (this.props.confirmOrder) {
			this.props.confirmOrder(this.props.item.id, this.props.item.orderId);
		}
	}

	public render() {
		const { id, status } = this.props.item;
		const { t } = this.props;

		return (
			<div className="shopDashboardOrderItemCard">
				<div className="innerHolder">
					<div className="orderId">
						<span className="silverText">{id}</span>
					</div>
					<div className="buttons">
						<WhiteButton onClick={this.handleRejectOrderClick} disabled={status > OrderStatus.Pending}>
							{t('Orders_OrderItemCard_Button_CancelOrder')}
						</WhiteButton>
						<WhiteButton onClick={this.handleConfirmClick} disabled={status !== OrderStatus.Pending}>
							{t('BSPortal_Common_Confirm')}
						</WhiteButton>
						<div className="lastBtn">
							<WhiteButton onClick={this.handleViewItemClick}>
								{<img src={require('containers/Html/icons/openicon.svg')} />}
							</WhiteButton>
						</div>
						<div className="clear" />
					</div>
				</div>
			</div>
		);
	}
}

export { ShopDashboardOrderItemCard };
